import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomMarker, StationTypeIcon } from "./CustomMarker";
import { getStationIcon } from "./utils";
export var StationMarker = function(param) {
    var deselect = param.deselect, select = param.select, selected = param.selected, setMarkerRef = param.setMarkerRef, station = param.station;
    var handleSelect = function() {
        select();
    };
    var handleDeselect = function() {
        deselect();
    };
    var StationIcon = getStationIcon(station.stationKind);
    return /*#__PURE__*/ _jsx(CustomMarker, {
        deselect: handleDeselect,
        id: station.id,
        isSelected: selected,
        select: handleSelect,
        setMarkerRef: setMarkerRef,
        station: station,
        position: {
            lat: station.latitude,
            lng: station.longitude
        },
        children: /*#__PURE__*/ _jsx(StationTypeIcon, {
            children: /*#__PURE__*/ _jsx(StationIcon, {})
        })
    });
};
